// BolKeBillHome.jsx

import React, { useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faMicrophone,
  faRobot,
  faFileInvoice,
  faEye,
  faFilePdf,
  faFileCsv,
  faDatabase,
  faUniversity,
  faMessage,
} from "@fortawesome/free-solid-svg-icons";

const dummyParsedItems = [
  {
    name: "Sticky Notes",
    unit: "Pack",
    qty: 5,
    rate: 50,
    hsn: "4820",
    gst: 12,
  },
  {
    name: "Gel Pens",
    unit: "Pcs",
    qty: 10,
    rate: 20,
    hsn: "9608",
    gst: 18,
  },
  {
    name: "A4 Papers",
    unit: "Ream",
    qty: 2,
    rate: 250,
    hsn: "4802",
    gst: 12,
  },
  {
    name: "Highlighters",
    unit: "Pcs",
    qty: 5,
    rate: 30,
    hsn: "9608",
    gst: 18,
  },
  {
    name: "Notebooks",
    unit: "Pcs",
    qty: 3,
    rate: 80,
    hsn: "4820",
    gst: 12,
  },
];

const BolKeBillHome = () => {
  const [docType, setDocType] = useState("invoice");
  const [customer, setCustomer] = useState("");
  const [voiceInput, setVoiceInput] = useState("");
  const [parsedItems, setParsedItems] = useState([]);
  const [items, setItems] = useState([]);
  const [showActions, setShowActions] = useState(false);
  const [showBill, setShowBill] = useState(false);

  const startVoice = () => {
    setCustomer("Rahul Stationers, Mumbai, 9876543210");

    setVoiceInput(`
Sticky Notes 5 pack 50 each
Gel Pens 10 pcs 20 each
A4 Papers 2 ream 250 each
Highlighters 5 pcs 30 each
Notebooks 3 pcs 80 each
`);
  };

  const parseAI = () => {
    setParsedItems(dummyParsedItems);
  };

  const addItems = () => {
    const updated = dummyParsedItems.map((item) => {
      const base = item.qty * item.rate;

      let cgst = 0;
      let sgst = 0;
      let igst = 0;
      let total = base;

      if (docType === "invoice") {
        cgst = (base * item.gst) / 100 / 2;
        sgst = (base * item.gst) / 100 / 2;
        total = base + cgst + sgst;
      }

      return {
        ...item,
        cgst,
        sgst,
        igst,
        total,
      };
    });

    setItems(updated);
  };

  const totals = useMemo(() => {
    return items.reduce(
      (acc, item) => {
        acc.qty += item.qty;
        acc.cgst += item.cgst;
        acc.sgst += item.sgst;
        acc.igst += item.igst;
        acc.total += item.total;

        return acc;
      },
      {
        qty: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        total: 0,
      }
    );
  }, [items]);

  const finalizeBill = () => {
    setShowActions(true);
  };

  const billCode = `BB-${Math.floor(Math.random() * 999999)}`;

  return (
    <div className="min-h-screen bg-black flex justify-center">
      <div className="w-full bg-black min-h-screen shadow-lg">

        {/* HEADER */}
        <div className="bg-black text-white p-4 sticky top-0 z-50">
          <h1 className="text-2xl font-bold text-center flex items-center justify-center gap-2">
            <FontAwesomeIcon icon={faFileInvoice} />
            BolKeBill
          </h1>
          <p className="text-xs lg:text-sm text-center text-gray-300 mt-1">
            Voice First AI Billing for MSMEs
          </p>
        </div>

        <div className="p-4 space-y-5">

          {/* DOCUMENT TYPE */}
          <div className="bg-gray-700 text-white rounded-2xl border p-4">
            <label className="text-sm font-semibold text-gray-100 mr-4">
              Select Document
            </label>

            <select
              value={docType}
              onChange={(e) => setDocType(e.target.value)}
              className="w-40 lg:w-64 text-xs lg:text-sm mt-2 border rounded-xl px-3 py-1 bg-gray-700 text-white"
            >
              <option value="invoice">Tax Invoice</option>
              <option value="receipt">Receipt</option>
              <option value="memo">Memo</option>
            </select>
          </div>

          {/* VOICE INPUT */}
          <div className="bg-gray-700 text-white rounded-2xl border p-4">
            <div className="flex items-center gap-2 mb-3">
              <FontAwesomeIcon icon={faMicrophone} className="text-green-600" />
              <h2 className="font-bold text-lg text-yellow-200">
                Voice Entry
              </h2>
            </div>

            <button
              onClick={startVoice}
              className="w-40 lg:w-64 text-xs lg:text-sm bg-green-600 hover:bg-green-700 text-white p-3 rounded-xl font-semibold"
            >
              Start Speaking
            </button>

            <input
              type="text"
              value={customer}
              onChange={(e) => setCustomer(e.target.value)}
              placeholder="Customer Details"
              className="w-full border rounded-xl p-3 mt-3 bg-gray-700"
            />

            <textarea
              value={voiceInput}
              onChange={(e) => setVoiceInput(e.target.value)}
              style={{height: "300px"}}
              placeholder="Voice transcript appears here"
              className="w-full border rounded-xl p-3 mt-3"
            />
          </div>

          {/* AI PARSE */}
          <div className="bg-gray-700 text-white rounded-2xl border p-4">

            <button
              onClick={parseAI}
              className="w-40 lg:text-64 text-xs lg:text-sm bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-xl font-semibold flex items-center justify-center gap-2"
            >
              <FontAwesomeIcon icon={faRobot} />
              Parse with AI
            </button>

            {parsedItems.length > 0 && (
              <div className="mt-4 bg-gray-800 rounded-2xl p-4 border">
                <h3 className="font-bold mb-3 text-yellow-200">
                  AI Parsed Items
                </h3>

                <div className="space-y-3 text-white">
                  {parsedItems.map((item, index) => (
                    <div
                      key={index}
                      className="bg-gray-700 text-white rounded-xl border p-3"
                    >
                      <div className="font-semibold text-white">
                        {item.name}
                      </div>

                      <div className="text-sm text-gray-100 mt-1 ">
                        Qty: {item.qty} {item.unit}
                      </div>

                      <div className="text-sm text-gray-100">
                        Rate: ₹{item.rate}
                      </div>

                      <div className="text-sm text-gray-100">
                        GST: {item.gst}%
                      </div>

                      <div className="text-sm text-gray-100">
                        HSN: {item.hsn}
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  onClick={addItems}
                  className="w-40 lg:w-64 text-xs lg:text-sm bg-blue-700 text-white p-3 rounded-xl mt-4"
                >
                  Add All Items
                </button>
              </div>
            )}
          </div>

          {/* ITEMS TABLE */}
          {items.length > 0 && (
            <div className="bg-gray-700 text-white rounded-2xl border p-4 overflow-auto">

              <h2 className="font-bold text-lg mb-4 text-yellow-200">
                Invoice Items
              </h2>

              <div className="overflow-x-auto">
                <table className="min-w-full text-xs border">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border p-2">SN</th>
                      <th className="border p-2">Item</th>
                      <th className="border p-2">Unit</th>
                      <th className="border p-2">Qty</th>
                      <th className="border p-2">Rate</th>
                      <th className="border p-2">GST%</th>
                      <th className="border p-2">CGST</th>
                      <th className="border p-2">SGST</th>
                      <th className="border p-2">Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {items.map((item, index) => (
                      <tr key={index}>
                        <td className="border p-2">{index + 1}</td>
                        <td className="border p-2">{item.name}</td>
                        <td className="border p-2">{item.unit}</td>
                        <td className="border p-2">{item.qty}</td>
                        <td className="border p-2">₹{item.rate}</td>
                        <td className="border p-2">{item.gst}%</td>
                        <td className="border p-2">
                          ₹{item.cgst.toFixed(2)}
                        </td>
                        <td className="border p-2">
                          ₹{item.sgst.toFixed(2)}
                        </td>
                        <td className="border p-2 font-semibold">
                          ₹{item.total.toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* TOTALS */}
              <div className="mt-4 bg-gray-800 rounded-xl p-4 text-sm">
                <div>Total Qty: {totals.qty}</div>
                <div>CGST: ₹{totals.cgst.toFixed(2)}</div>
                <div>SGST: ₹{totals.sgst.toFixed(2)}</div>
                <div className="font-bold text-lg mt-2">
                  Grand Total: ₹{totals.total.toFixed(2)}
                </div>
              </div>
            </div>
          )}

          {/* FINALIZE */}
          <button
            onClick={finalizeBill}
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white p-4 rounded-2xl font-bold"
          >
            Prepare Final Bill
          </button>

          {/* ACTIONS */}
          {showActions && (
            <div className="grid grid-cols-3 lg:grid-cols-6 gap-3">

              <button
                onClick={() => setShowBill(!showBill)}
                className="bg-gray-400 text-white p-3 rounded-xl text-sm flex items-center justify-center gap-2"
              >
                <FontAwesomeIcon icon={faEye} />
                View Bill
              </button>

              <button
                className="bg-red-600 text-white p-3 rounded-xl text-sm flex items-center justify-center gap-2"
              >
                <FontAwesomeIcon icon={faFilePdf} />
                PDF
              </button>

              <button
                className="bg-green-600 text-white p-3 rounded-xl text-sm flex items-center justify-center gap-2"
              >
                <FontAwesomeIcon icon={faMessage} />
                Share
              </button>

              <button
                className="bg-blue-600 text-white p-3 rounded-xl text-sm flex items-center justify-center gap-2"
              >
                <FontAwesomeIcon icon={faDatabase} />
                JSON
              </button>

              <button
                className="bg-orange-500 text-white p-3 rounded-xl text-sm flex items-center justify-center gap-2"
              >
                <FontAwesomeIcon icon={faFileCsv} />
                CSV
              </button>

              <button
                className="bg-purple-600 text-white p-3 rounded-xl text-sm flex items-center justify-center gap-2"
              >
                <FontAwesomeIcon icon={faUniversity} />
                Tally
              </button>
            </div>
          )}

          {/* BILL VIEW */}
          {showBill && (
            <div className="bg-gray-700 text-white rounded-2xl border p-4">

              <div className="text-center border-b pb-3">
                <h2 className="font-bold text-xl text-white">
                  ABC Traders
                </h2>

                <p className="text-sm text-gray-100">
                  GSTIN: 22AAAAA0000A1Z5
                </p>

                <p className="text-sm text-gray-100">
                  Mumbai, Maharashtra
                </p>

                <p className="text-sm text-gray-100">
                  9999999999 | abc@mail.com
                </p>
              </div>

              <div className="mt-4 text-sm space-y-1">
                <div className="text-gray-100">
                  <span className="font-semibold">
                    Customer:
                  </span>{" "}
                  {customer}
                </div>

                <div className="text-gray-100">
                  <span className="font-semibold">
                    Bill No:
                  </span>{" "}
                  INV-001
                </div>

                <div className="text-gray-100">
                  <span className="font-semibold">
                    Date:
                  </span>{" "}
                  {new Date().toLocaleDateString()}
                </div>

                <div className="text-gray-100">
                  <span className="font-semibold">
                    Bill Code:
                  </span>{" "}
                  {billCode}
                </div>
              </div>

              <div className="overflow-auto mt-4">
                <table className="min-w-full text-xs border">
                  <thead className="bg-gray-800">
                    <tr>
                      <th className="border p-2">Item</th>
                      <th className="border p-2">Qty</th>
                      <th className="border p-2">Rate</th>
                      <th className="border p-2">GST</th>
                      <th className="border p-2">Total</th>
                    </tr>
                  </thead>

                  <tbody>
                    {items.map((item, index) => (
                      <tr key={index}>
                        <td className="border p-2">
                          {item.name}
                        </td>

                        <td className="border p-2">
                          {item.qty} {item.unit}
                        </td>

                        <td className="border p-2">
                          ₹{item.rate}
                        </td>

                        <td className="border p-2">
                          {item.gst}%
                        </td>

                        <td className="border p-2 font-semibold">
                          ₹{item.total.toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="mt-4 bg-gray-700 rounded-xl p-4">
                <div>Total Qty: {totals.qty}</div>
                <div>CGST: ₹{totals.cgst.toFixed(2)}</div>
                <div>SGST: ₹{totals.sgst.toFixed(2)}</div>

                <div className="font-bold text-lg mt-2">
                  Grand Total ₹{totals.total.toFixed(2)}
                </div>

                <div className="mt-3 text-xs text-gray-100">
                  Terms: Goods once sold not returnable.
                </div>
              </div>

            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default BolKeBillHome;